import React, { Component } from 'react';
import Sidebar from '../../Components/Sidebar';
import Btn from '../../Components/Btn';
import BookingsTable from './Components/BookingsTable';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { search, getStats, getChart, setStatus, setVariable } from '../../store/search/actions';
import { numberWithCommas } from '../../helpers/formatters';
import LoadingOverlay from 'react-loading-overlay';
import BookingDatePicker from './BookingDatePicker'
import { loaderstyle } from '../../config';
import Searchbar from '../../Components/Searchbar';
import CompoChart from '../../Components/CompoChart';

class Bookings extends Component {
    state = {
        syncActive: false,
    };

    componentDidMount() {
        if(!this.props.autoSearched) {
            this.search({ resetPage: true });
        }
    }

    toggleSyncClasses = () => {
        this.setState({ syncActive: !this.state.syncActive });
        setTimeout(() => {
            this.setState({ syncActive: false });
        }, 3000);
    };

    search = () => {
        this.props.search({ resetPage: true });
        this.props.getStats();
        this.props.getChart();
    };

    setStatus = e => {
        const val = e.target.value;
        this.props.setStatus(val === "all" ? undefined : val);
        this.search();
    };

    setVariable = e => {
        this.props.setVariable(e.target.value);
    };

    render() {
        let syncClasses = this.state.syncActive ? "overlay_visible" : "";
        
        const stats = this.props.stats;
        const cc_stats = stats.cc;
        const cash_stats = stats.cash;
        const chart_data = this.props.chartData; 
        return (
            <div className="wrapper">
                <Sidebar />

                <div className="main-panel">
              
                    <div className="page-title">
                        <div className="page-title-heading">
                            <h1>Bookings</h1>
                            {/* <Btn className="btn simple" onClick={(event) => { event.preventDefault(); this.toggleSyncClasses() }}><img src="/imgs/icons/sync.png" alt="sync icon" width="12"/>sync</Btn> */}
                            <div
                                className={`overlay overlay-sync ${syncClasses}`}
                            >
                                <p>Syncing Bookings and Customers …</p>
                            </div>
                        </div>
                        <div className="page-title-actions">
                            <form onSubmit={e => e.preventDefault()}>
                                <div className="form-field">
                                    <h5 className="label">Status</h5>
                                    <select onChange={this.setStatus}>
                                        <option value="all">All</option>
                                        <option value="success">Success</option>
                                        <option value="pending">Pending</option>
                                        <option value="cancelled">
                                            Cancelled
                                        </option>
                                        <option value="partially_cancelled">
                                            Cancelled Not Refunded
                                        </option>
                                    </select>
                                </div>

                                <BookingDatePicker
                                    from={this.props.date.from}
                                    to={this.props.date.to}
                                />

                                <Searchbar 
                                    label="Search"
                                    value={this.props.variable}
                                    placeholder="Booking No., Name, Email, Phone, Trip No."
                                    onChange={this.setVariable}/>
                                <div className="form-field">
                                    <Btn
                                        className="btn simple small"
                                        onClick={this.search}
                                    >
                                        Search
                                    </Btn>
                                </div>
                            </form>
                        </div>
                    </div>
                    <hr />

                    <LoadingOverlay
                        active={this.props.loading_stats}
                        text="Loading..."
                        spinner
                        styles={loaderstyle}
                    >
                       {/** This a composed chart to represent 3 factors: Bookings, Seats & Net Revenue */}
                        <CompoChart
                            data={chart_data} 
                        />

                        {/** Statistics Cards */}
                        <div className="bookings-statics">
                            <div className="grid-row">
                                <div className="grid-col grid-col_6">
                                    <div
                                        className="statics-box"
                                        data-color="green"
                                    >
                                        <h4 className="statics-title green">
                                            Net Revenue
                                        </h4>
                                        <div className="statics-data">
                                            <h3 className="statics-price green">
                                                {numberWithCommas(
                                                    cc_stats.paid.total +
                                                        cash_stats.paid.total
                                                )}{" "}
                                                EGP
                                                <span className="statics-arrow up" />
                                            </h3>
                                            <h5 className="statics-bookings">
                                                {numberWithCommas(
                                                    cc_stats.paid.count +
                                                        cash_stats.paid.count
                                                )}{" "}
                                                Bookings
                                            </h5>
                                            <h5 className="statics-bookings">
                                                {numberWithCommas(
                                                    cc_stats.paid.seats +
                                                        cash_stats.paid.seats
                                                )}{" "}
                                                Passenger Tickets
                                            </h5>
                                            <div className="statics-info">
                                                <p>
                                                    {numberWithCommas(
                                                        cc_stats.paid.total
                                                    )}{" "}
                                                    EGP Credit Card (
                                                    {cc_stats.paid.ratio}%)
                                                    <span className="statics-arrow up" />
                                                </p>
                                                <p>
                                                    {numberWithCommas(
                                                        cash_stats.paid.total
                                                    )}{" "}
                                                    EGP Cash (
                                                    {cash_stats.paid.ratio}%)
                                                    <span className="statics-arrow up" />
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="grid-col grid-col_6">
                                    <div className="statics-box">
                                        <h4 className="statics-title">
                                            Cancelled Bookings
                                        </h4>
                                        <div className="statics-data">
                                            <h3 className="statics-price">
                                                {numberWithCommas(
                                                    cc_stats.cancelled.total
                                                    + cash_stats.cancelled.total
                                                )}{" "}
                                                EGP
                                                <span className="statics-arrow down" />
                                            </h3>
                                            <h5 className="statics-bookings">
                                                {cc_stats.cancelled.count
                                                +cash_stats.cancelled.count}{" "}
                                                Bookings
                                            </h5>
                                            <div className="statics-info">
                                                <p>
                                                    {numberWithCommas(
                                                        cc_stats.cancelled.total
                                                    )}{" "}
                                                    EGP Credit Card (
                                                    {cc_stats.cancelled.ratio}%)
                                                    <span className="statics-arrow down" />
                                                </p>
                                                <p>
                                                    {numberWithCommas(
                                                        cash_stats.cancelled.total
                                                    )} EGP Cash ({cash_stats.cancelled.ratio}%)
                                                    <span className="statics-arrow down"></span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="grid-col grid-col_6">
                                    <div className="statics-box">
                                        <h4 className="statics-title">
                                            All Bookings
                                        </h4>
                                        <div className="statics-data">
                                            <h3 className="statics-price">
                                                {numberWithCommas(
                                                    stats.all_total
                                                )}{" "}
                                                EGP
                                                <span className="statics-arrow down" />
                                            </h3>
                                            <h5 className="statics-bookings">
                                                {stats.all_count} Bookings
                                            </h5>
                                            <div className="statics-info">
                                                <p>
                                                    {numberWithCommas(
                                                        cc_stats.total
                                                    )}{" "}
                                                    EGP Credit Card (
                                                    {cc_stats.ratio}%)
                                                    <span className="statics-arrow down" />
                                                </p>
                                                <p>
                                                    {numberWithCommas(
                                                        cash_stats.total
                                                    )}{" "}
                                                    EGP Cash ({cash_stats.ratio}
                                                    %)
                                                    <span className="statics-arrow up" />
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="grid-col grid-col_12">
                                    <div className="statics-box">
                                        <h4 className="statics-title">
                                            Channels
                                        </h4>
                                        <div className="statics-data-multi">
                                            <div className="statics-data">
                                                <h3 className="statics-price">
                                                    0 EGP
                                                    <span className="statics-arrow up" />
                                                </h3>
                                                <h5 className="statics-bookings">
                                                    Website 0 Bookings
                                                </h5>
                                                <div className="statics-info">
                                                    <p>0 EGP Desktop</p>
                                                    <p>0 EGP Mobile</p>
                                                </div>
                                            </div>
                                            <div className="statics-data">
                                                <h3 className="statics-price">
                                                    0 EGP
                                                    <span className="statics-arrow down" />
                                                </h3>
                                                <h5 className="statics-bookings">
                                                    Mobile App 0 Bookings
                                                </h5>
                                                <div className="statics-info">
                                                    <p>0 EGP Andriod</p>
                                                    <p>0 EGP iOS</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <BookingsTable />
                    </LoadingOverlay>
                   
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    date: state.search.searchOptions.date,
    loading_stats: state.search.loading_stats,
    loading_search: state.search.loading_search,
    loading_chart: state.search.loading_chart,
    stats: state.tickets.stats,
    chartData: state.tickets.chartDta,
    variable: state.search.searchOptions.variable,
    autoSearched: state.search.autoSearched,
});

const mapDispatchToProps = dispatch => ({
    search: bindActionCreators(search, dispatch),
    getStats: bindActionCreators(getStats, dispatch),
    getChart: bindActionCreators(getChart, dispatch),
    setStatus: bindActionCreators(setStatus, dispatch),
    setVariable: bindActionCreators(setVariable, dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Bookings);
